<template lang="html">
  <div class= "icons-crowd">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.3/css/all.css">
    <!-- <a class="button is-light">Twitter</a>
    <a class="button is-light">Instagram</a>
    <a class="button is-light">Facebook</a>
    <a class="button is-light">YouTube</a>
    <a class="button is-light">GitHub</a> -->

    <span class="icon">
      <a href = "https://twitter.com/ken3_305" target="_blank">
        <i class = "fab fa-twitter"></i>
      </a>
    </span>
    <span class="icon">
      <a href = "https://instagram.com/ken3_305" target="_blank">
        <i class = "fab fa-instagram"></i>
      </a>
    </span>
    <span class="icon">
      <a href = "https://facebook.com/ken3.305" target="_blank">
        <i class = "fab fa-facebook"></i>
      </a>
    </span>
    <span class="icon">
      <a href = "https://www.youtube.com/channel/UCNhKjJj9BkOSnEsjUZ6pkYA?view_as=subscriber" target="_blank">
        <i class = "fab fa-youtube"></i>
      </a>
    </span>
    <span class="icon">
      <a href = "https://github.com/ken3-305" target="_blank">
        <i class = "fab fa-github"></i>
      </a>
    </span>
    <span class="icon">
      <a href = "http://nkmr-lab.org/" target="_blank">
        <i class = "fas fa-laptop"></i>
      </a>
    </span>
  </div>
</template>

<script>
export default {
  mounted() {
    window.addEventListener('scroll', () => {
      var iconsCrowd = document.querySelector(".icons-crowd");
      iconsCrowd.classList.toggle("scroll-nav", window.scrollY > 40);
    });
  }
}
</script>

<style lang="css" scoped>

.icon {
  position: relative;
  /* background-color: #a00; */
}

.icon a {
  color: #FFF;
}

.icon a:hover {
  transition: color 0.2s;
  color: #B7B7B7;
}

.icons-crowd.scroll-nav .icon a {
  transition: color 0.2s;
  color: #303030;
}

.icons-crowd.scroll-nav .icon a:hover {
  transition: color 0.2s;
  color: #979797;
}
</style>
